import { Injectable } from '@angular/core';
import { DialogService } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog.service';
import { ChooseTemplateModalContainerComponent } from './containers/choose-template-modal-container/choose-template-modal-container.component';
import { ECommerceProductTemplatesFacade } from '@api-ui-app/src/app/e-commerce-product-templates/e-commerce-product-templates.facade';
import { ItemToStore } from '@api-ui-app/src/app/choose-template-modal/types/item-to-store';
import { ChooseTemplateModalData } from '@api-ui-app/src/app/choose-template-modal/types/choose-template-modal-data';
import { EProductTemplatesSearchParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-params';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ChooseTemplateModalFacade {
  isLoading$ = combineLatest([
    this.eCommerceProductTemplatesFacade.isLoading$,
    this.eCommerceProductTemplatesFacade.isProcessing$,
  ]).pipe(map(([isLoading, isProcessing]) => isLoading || isProcessing));
  constructor(
    private readonly dialogService: DialogService,
    private readonly eCommerceProductTemplatesFacade: ECommerceProductTemplatesFacade,
  ) {}

  openModal(context?: ChooseTemplateModalData): void {
    this.dialogService.open(ChooseTemplateModalContainerComponent, {
      data: context,
    });
  }
  addTemplateToStore(item: ItemToStore) {
    this.eCommerceProductTemplatesFacade.dispatchAddProductTempalateToStoreAction(item.storeId, item.id);
  }

  changeSearchParams(params: EProductTemplatesSearchParams) {
    this.eCommerceProductTemplatesFacade.setSearchParams(params);
  }
}
